<template>
  <div id="main-content" class="edit-class">
    <el-col :offset="1" :span="22">
      <PageTitle :title="title" :backLink="backLink"></PageTitle>
      <form>
        <el-row class="mt-3">
          <el-col :span="12" style="display: inline">
            <el-col :span="8">
              <span class="required-star">* </span><span class="form-lable">{{ $t('grade.name') }}</span>
            </el-col>
            <el-col :span="16">
              <el-input v-model="grade.name"></el-input>
            </el-col>
            <el-col v-if="errName" :offset="8" :span="16">
              <span class="form-error"> {{ errName }}</span>
            </el-col>
          </el-col>

        </el-row>


        <el-row style="padding-top: 50px">
          <el-button style="font-size: 20px; width: 30%" type="success" @click="submitAction">{{ $t('common.submit') }}</el-button>
        </el-row>
      </form>
    </el-col>
  </div>
</template>

<script>
import PageTitle from '../../components/PageTitle.vue'

export default {
  name: "EditClass",
  components: {
    PageTitle
  },
  data: function () {
    return {
      title:'grade.titleCreate',
      backLink:'/grade-management',
      grade:{
        id:null,
        name:null
      },
      isEdit:false,
      errName:null
    }
  },
  created(){

  },
  mounted() {
    if(this.$route.query.id){
      this.title='grade.titleEdit'
      this.onGetGradeById(this.$route.query.id)
      this.isEdit = true
    }else{
      this.title='grade.titleCreateForm'
      this.isEdit = false
    }
  },
  methods:{
    onGetGradeById(id){
      let payload ={
        successCallback: (response) =>{
          if(response.status === 200){
            this.grade= response.data.data.grade
          }
        },
        errorCallback: () => {},
        grade_id:id
      }
      this.$store.dispatch('classroom/getGradeById', payload)
    },
    submitAction(){
      let check = this.validate()
      if(check){
        let payload = {
          successCallback: ( response) =>{
            if(response.status ===200){
              this.$router.push('/grade-management')
              this.$notify({
                title: this.$t('msg.titleSuccess'),
                message: this.isEdit ? this.$t('msg.contentUpdateSuccess', { field: this.$t('nameField.grade') }) : this.$t('msg.contentCreateSuccess', { field: this.$t('nameField.grade') }),
                type: 'success'
              })
            }
          },
          errorCallback: ()=>{},
          data:Object.assign({}, this.grade),
          grade_id: this.grade.id
        }
        if(this.grade.id){
          this.$store.dispatch('classroom/updateGrade', payload)
        }else{
          this.$store.dispatch('classroom/createGrade', payload)
        }

      }
    },
    validate(){
      let check = true
      let {grade} = this
      if(!grade.name || (grade.name && grade.name.trim()==='')){
        this.errName = this.$t('msg.required', {field: this.$t('grade.name')})
        check = false
      }else{
        this.errName =''
      }
      return check
    }
  }
}
</script>

<style lang="scss">
</style>
